module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "screen-share-dialog",
    class: {
      'show': _vm.show
    },
    style: ({
      'background-color': _vm.$store.state.campaign.color,
      'color': _vm.invertColor(this.$store.state.campaign.color)
    })
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('shareScreen')))]), _vm._v(" "), _c('v-btn', {
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    }),
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.yes($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('yes')))]), _vm._v(" "), _c('v-btn', {
    style: ({
      'color': _vm.invertColor(this.$store.state.campaign.color)
    }),
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.no($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('no')))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79ddec6f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screen-share-dialog.vue
// module id = 410
// module chunks = 2